<template>
    <div class="base-activity-details" :class="{'actde-sp': $store.state.screen == 1}">
        <div class="header">
            <div class="back-img" @click="$router.back()">
                <img class="back" src="~images/back.png" />
            </div>
            <div class="title">活动详情</div>
            <div class="service-img" @click="$router.push('/base-service')">
                <img class="ser" src="~images/user_service.png" />
            </div>
        </div>
        <div class="content" v-show="isyes">
            <div class="box">
                <div class="top">
                    <div class="mark">{{statusName}}</div>
                    <div class="title">{{info.title}}</div>
                </div>
                <div class="time">{{info.add_time | dateTime}}</div>
            </div>
            <div class="detalis">{{info.content}}</div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        // 进入路由之前
        beforeRouteEnter (to, from, next) {
            next(vm => {
                vm.getList()
            })
        },
        name: 'BaseActivityDetails',
        data () {
            return {
                accountData: {},
                info: {},
                config: [],
                statusName: '',
                isyes: false,
                h5LoginData:{}
            }
        },
        watch: {
            config () {
                this.config.forEach((item, index, arr) => {
                    if (item.id == (JSON.parse(this.info.level))) {
                        this.statusName = item.name
                    }
                })
            }
        },
        filters: {
            dateTime (time) {
                return moment.unix(time).format('YYYY-MM-DD HH:mm')
            }
        },
        methods: {
            // 活动列表
            getList () {
                let options = {
                    id: this.$route.query.id,
                    appid: this.accountData.appid,
                    channel: this.accountData.channel ?this.accountData.channel :this.h5LoginData.channel
                }
                options.sign = this.util.getSign(options, this.accountData.appkey)
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=notice&a=getNoticeInfo', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.info = res.data.data.info
                        this.config = res.data.data.config
                        this.isyes = true
                    }
                })
            }
        },
        created () {
            this.accountData = JSON.parse(sessionStorage.getItem('accountData'))
            this.h5LoginData = JSON.parse(sessionStorage.getItem('h5LoginData'))

        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-activity-details {
        width: 1080px;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        flex-direction: column;
        transition: all 0.3s;
        .header {
            height: 132px;
            background: rgba($color, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            .back-img {
                width: 192px;
                height: 132px;
                position: absolute;
                left: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                .back {
                    width: 72px;
                    height: 72px;
                }
            }
            .title {
                font-size: 51px;
                text-align: center;
            }
            .service-img {
                width: 192px;
                height: 132px;
                position: absolute;
                right: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                .ser {
                    width: 72px;
                    height: 72px;
                }
            }
        }
        .content {
            flex: 1;
            overflow-y: scroll;
            padding: 60px 60px 0;
            .box {
                border-bottom: 2px solid rgba(255, 255, 255, 0.5);
                padding-bottom: 60px;
                margin-bottom: 30px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .top {
                    display: flex;
                    align-items: center;
                }
                .mark {
                    min-width: 96px;
                    height: 45px;
                    font-size: 33px;
                    border-radius: 3px;
                    background: $color;
                    margin-right: 15px;
                    padding: 0 17px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .title {
                    max-width: 750px;
                    font-size: 45px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .time {
                    font-size: 36px;
                    color: rgba(255, 255, 255, 0.5);
                    margin-top: 15px;
                }
            }
            .detalis {
                font-size: 39px;
                color: rgba(255, 255, 255, 0.5);
                margin-bottom: 60px;
            }
        }
    }
    // 竖屏css
    .actde-sp {
        width: 100%;
        height: 100%;
        .header {
            height: 240px;
            border-radius: 60px 0 0 0;
            .back-img {
                width: 290px;
                height: 240px;
                .back {
                    width: 130px;
                    height: 130px;
                }
            }
            .title {
                font-size: 92px;
            }
            .service-img {
                width: 290px;
                height: 240px;
                .ser {
                    width: 130px;
                    height: 130px;
                }
            }
        }
        .content {
            padding: 90px 90px 0;
            .box {
                border-bottom: 3px solid rgba(255, 255, 255, 0.5);
                padding-bottom: 90px;
                margin-bottom: 54px;
                .mark {
                    min-width: 174px;
                    height: 81px;
                    font-size: 60px;
                    border-radius: 5px;
                    margin-right: 27px;
                    padding: 0 30px;
                }
                .title {
                    max-width: 1000px;
                    font-size: 81px;
                }
                .time {
                    font-size: 65px;
                    margin-top: 27px;
                }
            }
            .detalis {
                font-size: 70px;
                margin-bottom: 90px;
            }
        }
    }
</style>